import * as React from "react";
import { Route, Redirect } from "react-router";

// TODO: AAH Figure out how to type the props here. To make this work, the component
// property is renamed to Component (capitalized) via the parameter destructuring so
// that we can use it like a JSX component in the returned Route component. However,
// when typed properly TS complains that the Component has no constructor.
const PrivateRoute = ({ component: Component, isAuthenticated, render, hasPermission, ...rest }: any) => {
  const getComponent = (props: any) => {
    return <Component {...props} />;
  };

  const getLoginRedirect = (props: any) => {
    return <Redirect to={{ pathname: "/login", state: { from: props.location } }} />;
  };

  if (isAuthenticated) {
    if (hasPermission) {
      return <Route {...rest} render={Component ? getComponent : render} />;
    } else {
      return null;
    }
  } else {
    return <Route {...rest} render={getLoginRedirect} />;
  }
};

export default PrivateRoute;
